import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Expedition 33 Simon Expert Glitchless" mdxType="SEO" />
    <h1 {...{
      "id": "clair-obscur-expedition-33-simon-expert-glitchless-route"
    }}>{`Clair Obscur: Expedition 33 Simon Expert Glitchless Route`}</h1>
    <p>{`Last update: 8/05/25.`}<br parentName="p"></br>{`
`}{`This route is pretty much Bdud5's Simon route + some optimizations. You can find his notes `}<a parentName="p" {...{
        "href": "https://docs.google.com/document/d/1sPU6fcfaGXDEwi8kLG-d-b_H7KWZtLkPmM5NI6kafQI/edit?tab=t.0"
      }}>{`here`}</a>{`.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "notation"
    }}>{`Notation`}</h3>
    <p>{`For menus, I will sometimes have something in parenthesis. If it's (S1-3), it refers to the slot the Picto should be placed in. If it's a Playstation controller button, it's a button you should press to optimize the menu.`}</p>
    <p>{`For battles, there will sometimes be something like (1.1 QTE). This refers to the Quick Time Action you do when you use an Ability. A perfect is 1.2, a normal is 1.1, and a fail is 1.0. The number refers to the damage multiplier the skill gets from the QTE.`}</p>
    <hr></hr>
    <p>{`You can check the changelog at the bottom of the notes.`}</p>
    <p>{`These are my personal notes for the category, the writing will reflect that. For the most part these notes will not say where to go or where things are, just what to do. I will be updating these as the route progresses, changes will be reflected in the changelog at the bottom of the notes.`}</p>
    <p>{`There will also be enemy data and maybe some other useful information at the bottom of the notes.`}</p>
    <p>{`If there's a time listed by a fight, it's my best time for it so far. It does not represent the average.`}</p>
    <h2 {...{
      "id": "prologue"
    }}>{`Prologue`}</h2>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "maelle-450hp-024-027"
      }}>{`Maelle 450HP (0:24-0:27)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1XP, $50, Colour of Lumina`}</p>
      </blockquote>
      <p>{`Option 1: Attack > Parry > Overcharge > Parry > Attack (0:24 w/crit, 0:27 without)`}<br parentName="p"></br>{`
`}{`Option 2: Attack > Parry > Attack > Dodge, Overcharge (0:26). If you get hit instead of dodging add 1 shot.`}</p>
      <p>{`On average, optimal choice is probably to go for Option 2 if you don't get the parry crit T1.`}<br parentName="p"></br>{`
`}{`If you crit an attack with Option 2, you can save 1s by intentionally getting hit by 1 of Maelle's 3 hits.`}</p>
    </Menu>
    <h3 {...{
      "id": "harbor"
    }}>{`Harbor`}</h3>
    <ul>
      <li parentName="ul">{`Talk to Aprentices`}</li>
      <li parentName="ul">{`Talk to Maelle, skip Maelle duel`}</li>
      <li parentName="ul">{`Talk to Emma`}</li>
    </ul>
    <p>{`4 CS on Transition`}</p>
    <h2 {...{
      "id": "act-i"
    }}>{`Act I`}</h2>
    <h3 {...{
      "id": "spring-meadows"
    }}>{`Spring Meadows`}</h3>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "lancelier-122hp-6xp-50-010"
      }}>{`Lancelier 122HP 6XP $50 (0:10)`}</h4>
      <ul>
        <li parentName="ul">{`Shoot Weak Spot, Attack > Parry`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "portier-450hp-008"
      }}>{`Portier 450HP (0:08)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`10XP, $75, Dodger + 0-2 Chroma Catalyst `}</p>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`You can shoot 2 extra times with Gustave. If he crits the attack, you can then shoot twice with Lune and Immolation to kill.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Shoot weak spot, Attack`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`For the attack party attack, start mashing dodge as soon as his arms touch together. After 3 dodges, parry.`}</p>
      </blockquote>
      <p>{`Parry to kill.`}</p>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Critical Burn`}</strong>{`.`}<br parentName="p"></br>{`
`}{`First strike the Lanceram before the house.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "2-lancelier-240hp-019"
      }}>{`2 Lancelier 240HP (0:19)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`53XP, $144, Lanceram LV1`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Shoot weak spots, Attack`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
      <p>{`Parry.`}</p>
      <h5 {...{
        "id": "turn-1-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Attack`}</li>
      </ul>
    </Menu>
    <p>{`You can jump up to the right side before the house, or take the path through the house.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`$360`}</strong>{` in house detour.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "3-volester-81hp-017"
      }}>{`3 Volester 81HP (0:17)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`43XP, $216, 0-2 Chroma Catalyst?`}<br parentName="p"></br>{`
`}{`Parry timing is on slowdown/freeze frames on both of their attacks`}</p>
      </blockquote>
      <p>{`Parry both attacks. Shoot last one to death. Requires 5AP.`}</p>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Dead Energy II`}</strong>{`. Afterwards, jump off to the left and menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Lanceram`}</li>
      </ul>
      <h5 {...{
        "id": "pictos"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustav`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
            <li parentName="ul">{`+Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`First strike the Abbest on your left.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "2-volester-abbest-009"
      }}>{`2 Volester Abbest (0:09)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$216, 55XP`}<br parentName="p"></br>{`
`}{`If you missed XP earlier, take the fight before Eveque instead. Strat for that fight is in the archive section of these notes.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-1"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Gustav:`}<ul parentName="li">
            <li parentName="ul">{`Shoot each Volester 3 times, don't hit weakness.`}</li>
            <li parentName="ul">{`Shoot Abbest weakness, skip.`}</li>
          </ul></li>
        <li parentName="ul">{`Lune: Ice Lance (1.1)`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Colour of Lumina`}</strong>{` under the bridge. Go to Flag.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Optionally, Lune equip Lighterim`}</p>
    </blockquote>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: +9 Might (9)`}</li>
        <li parentName="ul">{`Lune: +9 Might (9)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot, Powerful (in that order)`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "eveque-4524hp-204"
      }}>{`Eveque 4524HP (2:04)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$862, Cleansing Tint, 5 Chroma Catalyst, 0-2 Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-2"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: (If Gustave target shoot 1 shield), Powerful`}</li>
        <li parentName="ul">{`Lune: Shoot off shields (last shield shoot weakpoint), Shoot till 3AP, Immolation`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Lune: Immolation`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Shoot till 2AP, Marking Shot`}</li>
        <li parentName="ul">{`Lune: Energising Tint Gustave`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Stop countering Eveque on this turn, until you do the Overcharge.`}<br parentName="p"></br>{`
`}{`Don't kill the Abbests! You need the bonus EXP you get from leaving them alive.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-4"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Overcharge`}</li>
      </ul>
      <p>{`If not dead, shoot off shields and damage as best as you can.`}<br parentName="p"></br>{`
`}{`If it was no crit and Eveque is still healthy, don't counter it's attack so it starts charging up. You can then inflict a good chunk of damage by shooting the core again.`}</p>
    </Menu>
    <h3 {...{
      "id": "continent"
    }}>{`Continent`}</h3>
    <p>{`Go to Camp before entering Flying Waters`}</p>
    <h3 {...{
      "id": "flying-waters"
    }}>{`Flying Waters`}</h3>
    <p>{`Pick up `}<strong parentName="p">{`$333`}</strong>{` along path.`}</p>
    <p>{`Take the detour to the right by the tunnel to spawn 3 Denerim and fight them.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "3-demineur-218hp-004"
      }}>{`3 Demineur 218HP (0:04)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1180XP $399`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-2"
      }}>{`Turn 0`}</h5>
      <p>{`Shoot the 3 bombs`}</p>
    </Menu>
    <p>{`Go to Manor.`}</p>
    <p>{`After getting Maelle menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-1"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
            <li parentName="ul">{`+Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Go to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-1"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: +6 Agility (6)`}</li>
        <li parentName="ul">{`Maelle: +15 Might (15)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-1"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
        <li parentName="ul">{`Lune: Wildfire`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "the-curator-hp-024"
      }}>{`The Curator ?HP (0:24)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`720XP, $376`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-3"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Skip`}</li>
        <li parentName="ul">{`Maelle: Offensive Shift`}</li>
        <li parentName="ul">{`Lune: Skip`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-1"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
    </Menu>
    <p>{`Talk to Noco and fight him.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "noco-1670hp-022"
      }}>{`Noco 1670HP (0:22)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`486XP $200 `}</p>
      </blockquote>
      <p>{`Offensive Shift > Parry > Percee`}</p>
    </Menu>
    <p>{`Buy `}<strong parentName="p">{`Exposing Attack ($3600)`}</strong>{`. After Noco continue straight.`}<br parentName="p"></br>{`
`}{`Fight the `}<strong parentName="p">{`Bruler`}</strong>{` that jumps down at you before the tunnel`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "demineur-bruler-luster-014"
      }}>{`Demineur, Bruler, Luster (0:14)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1412XP, $466, Bruleram LV3`}<br parentName="p"></br>{`
`}{`You get ~72 more EXP here by killing Bruler first.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-3"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Shoot Mine, Marking Shot Bruler`}</li>
        <li parentName="ul">{`Lune: Ice Lance Luster (Optional)`}</li>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`Shoot Bruler weakspot (kill)`}</li>
            <li parentName="ul">{`Shoot Demineur three times`}</li>
            <li parentName="ul">{`Shoot rest of AP at Luster weakspot, if he lives Attack`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Talk to Coral Cave Flag`}</p>
    <Menu mdxType="Menu">
      <ul>
        <li parentName="ul">{`Gustav: +4 Might (13), +1 Agility (7)`}</li>
        <li parentName="ul">{`Maelle: +2 Might (17), +1 Agility (1)`}</li>
        <li parentName="ul">{`Lune: +8 Might (17), +4 Agility (4)`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon-1"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Bruleram`}</li>
        <li parentName="ul">{`Lune: Lighterim (If not done earlier)`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-2"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Exposing Attack`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
          </ul></li>
        <li parentName="ul">{`Gustav`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "goblu-22815hp-137"
      }}>{`Goblu 22815HP (1:37)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`3240XP, $1330, 0-2? Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-4"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Gustav: Powerful`}</li>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Can shoot all ATB, Attack`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-1"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
        <li parentName="ul">{`Gustav: Overcharge`}</li>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4-1"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Can shoot all ATB, Attack`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
      <p>{`If still alive, try to setup Marking Shot > Percee again.`}</p>
    </Menu>
    <h3 {...{
      "id": "ancient-sanctuary"
    }}>{`Ancient Sanctuary`}</h3>
    <blockquote>
      <p parentName="blockquote">{`If you've been hitless since getting Maelle, you can use the flag at the start here for Maelle Might. If so, you can skip Powerful vs Robust Sakapatate.`}</p>
    </blockquote>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "robust-sakapatate-5792hp-039"
      }}>{`Robust Sakapatate 5792HP (0:39)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1824XP, $435, Sakaram Lv.4`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Swings with it's partner: 1 Hit AoE`}</li>
          <li parentName="ul">{`Slams it's shield: 1 Hit AoE, raises Shield and will counter next time its hit.`}</li>
          <li parentName="ul">{`Shield counter: 1 hit AoE, need to dodge sooner than Slams it's shield.`}</li>
          <li parentName="ul">{`Clunky Combo: 2 hit, jump, 1 hit. Has easy audio cue`}</li>
        </ul>
      </blockquote>
      <p>{`Parry his shield attack (prevents him countering later). You can dodge everything else.`}</p>
      <h5 {...{
        "id": "turn-1-5"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation (Fail QTE)`}</li>
        <li parentName="ul">{`Gustav: Powerful`}</li>
        <li parentName="ul">{`Maelle: Swift Strike (Fail QTE)`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-3"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
    </Menu>
    <p>{`Talk to flag before Ultimate Sakapatate`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-2"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +9 Might (23)`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "ultimate-sakapatate-28236hp-144"
      }}>{`Ultimate Sakapatate 28236HP (1:44)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`8100XP, $1930, Breaker + 3 Polished Catalyst + 0-2 Recoats`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Slams the ground: 1 hit AoE, naturally parry timing.`}</li>
          <li parentName="ul">{`Fires it's Cannons: look for Fire on it's cannons as indicator, parry when you see it.`}</li>
          <li parentName="ul">{`Slams it's shield: 1 hit single target.`}</li>
          <li parentName="ul">{`Combo: 2 hits into jump, dodge the first 2 no point in parrying.`}</li>
          <li parentName="ul">{`Launches weird elecric things: 3 hit single target: Parry once they're top of their arc / flying down.`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-1-6"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
        <li parentName="ul">{`Gustav: Powerful`}</li>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-4"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Shoot once, then shoot shoulder 3 times to break it. Attack.`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If Gustave doesn't have 5AP, you can Powerful instead, or just Attack.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-3-2"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
        <li parentName="ul">{`Gustav: Overcharge`}</li>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4-2"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack / Energy Tint Gustave if he has 0 AP.`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
      <p>{`If still alive, repeat turn 4`}</p>
    </Menu>
    <p><strong parentName="p">{`After fight`}</strong>{`, go to right and pick up `}<strong parentName="p">{`Stun Boost`}</strong>{` and `}<strong parentName="p">{`Energy Tint`}</strong>{`.`}</p>
    <h3 {...{
      "id": "gestral-village"
    }}>{`Gestral Village`}</h3>
    <p>{`Go to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "learn-skills-2"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Degagement, Rain of Fire`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "tournament"
    }}>{`Tournament`}</h3>
    <p>{`Pattern for first 3 fights: Parry, `}<strong parentName="p">{`Degagement`}</strong>{`, Parry, Rain of Fire`}<br parentName="p"></br>{`
`}{`Rewards for each: 2026XP, $366`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "bertrand-big-hands-022"
      }}>{`Bertrand Big Hands (0:22)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Swinging Right Hook x2, Left Uppercut (parry end of windup)`}</p>
      </blockquote>
      <h4 {...{
        "id": "dominique-giant-feet-027"
      }}>{`Dominique Giant Feet (0:27)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Two-handed Ground Pound x2, Right Handed Ground Pound (Parry indicator is his elbow pointing up)`}</p>
      </blockquote>
      <h4 {...{
        "id": "matthieu-the-colossus-023"
      }}>{`Matthieu the Colossus (0:23)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Left Hook x2, Right `}<strong parentName="p">{`Feint`}</strong>{` into Left Uppercut (Parry as he swings)`}</p>
      </blockquote>
      <h4 {...{
        "id": "sciel-3211hp-024"
      }}>{`Sciel 3211HP (0:24)`}</h4>
      <p>{`Parry, Rain of Fire, Parry`}</p>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Sealed Fate: 3 Hit`}</li>
          <li parentName="ul">{`Twilight Slash: 1 Hit`}</li>
          <li parentName="ul">{`Marking Card: 2 hit projectile, Parry as circle closes.`}</li>
        </ul>
      </blockquote>
      <p>{`You need to win vs Sciel for this route.`}</p>
    </Menu>
    <p>{`Talk to Golgra. Then go talk to Jujubree (Merchant).`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`2 Polished Chrome Catalyst (2000)`}</li>
        <li parentName="ul">{`Critical Moment (5520)`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "camp"
    }}>{`Camp`}</h4>
    <p>{`Sleep. Go to Esquie's Nest.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-3"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustave:`}<ul parentName="li">
            <li parentName="ul">{`+Critical Moment`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "weapons"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Medalum`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "esquies-nest"
    }}>{`Esquie's Nest`}</h3>
    <p>{`Go to flag by entrance.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-3"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: +13 Agility (20)`}</li>
        <li parentName="ul">{`Maelle: +9 Might (32)`}</li>
        <li parentName="ul">{`Sciel: +45 Might (45)`}</li>
        <li parentName="ul">{`Lune: +15 Might (29)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-3"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
        <li parentName="ul">{`Lune: Equip Lightning Dance to Bottom Left slot`}</li>
        <li parentName="ul">{`Sciel: `}<strong parentName="li">{`Phantom Blade`}</strong>{`, Intervention`}</li>
        <li parentName="ul">{`Sciel: Equip Intervention to Top Left slot`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "francois-9652hp-018"
      }}>{`Francois 9652HP (0:18)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`2228XP, $392, 345SPD, Augmented First Strike + 0-2 Polished Chroma Catalyst`}</p>
      </blockquote>
      <p>{`Dodge his attacks, use rhythm like Eveque spells`}</p>
      <h5 {...{
        "id": "turn-1-7"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Lune: Attack`}</li>
        <li parentName="ul">{`Maelle: Shoot 3 times, Percee`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Better to shoot with Maelle because you don't have to move your aim at all.`}</p>
      </blockquote>
    </Menu>
    <p>{`Backtrack to Esquie.`}<br parentName="p"></br>{`
`}{`After talking to Esquie, run to flag by Francois and fast travel to entrance.`}</p>
    <h3 {...{
      "id": "the-continent"
    }}>{`The Continent`}</h3>
    <p>{`Picked `}<strong parentName="p">{`Colour of Lumina`}</strong>{` by the Demineur, Lancelier, Crueler. Then camp.`}</p>
    <h4 {...{
      "id": "camp-1"
    }}>{`Camp`}</h4>
    <p>{`Talk to Curator`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lighterim +6 (7)`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "the-continent-1"
    }}>{`The Continent`}</h3>
    <p>{`First strike the group here.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "demineur-crueler-lancelier-020"
      }}>{`Demineur, Crueler, Lancelier (0:20)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`4333XP, $914, Lanceram LV6 Cruleram LV6`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-8"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav:`}<ul parentName="li">
            <li parentName="ul">{`Shoot Lancelier Weakpoint`}</li>
            <li parentName="ul">{`Shoot Demineur Mine`}</li>
            <li parentName="ul">{`Marking Shot Crueler (1 Right)`}</li>
          </ul></li>
        <li parentName="ul">{`Lune: Wildfire (Fail QTE)`}</li>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`Headshot Demineur`}</li>
            <li parentName="ul">{`Shoot Lancelier 7 times`}</li>
            <li parentName="ul">{`Percee Crueler`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Energising Start I`}</strong>{` on beach west of `}<strong parentName="p">{`Stone Wave Cliffs`}</strong><br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`$1775`}</strong>{` near Chromatic Bruler.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`$1305`}</strong>{` after breaking the rocks to Stone Wave Cliffs`}</p>
    <h3 {...{
      "id": "stone-wave-cliffs"
    }}>{`Stone Wave Cliffs`}</h3>
    <p>{`Pick up `}<strong parentName="p">{`$790`}</strong>{` on the left before the 1st flag.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Colour of Lumina`}</strong>{` after grapple.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`First Strike`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`Optimally, you want to do this menu before you get SOS Power. Ideally, jumping down from the First Strike area.`}</p>
      </blockquote>
      <h5 {...{
        "id": "formation"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`-Maelle, +Sciel`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-4"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Augmented First Strike`}</li>
            <li parentName="ul">{`+Breaker`}</li>
            <li parentName="ul">{`+Energising Start I`}</li>
          </ul></li>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+First Strike`}</li>
            <li parentName="ul">{`+Critical Moment`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-1"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Dodger`}</li>
          </ul></li>
        <li parentName="ul">{`Gustav:`}<ul parentName="li">
            <li parentName="ul">{`-Critical Burn`}</li>
            <li parentName="ul">{`+Exposing Attack`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`(L2) +Dead Energy II`}</li>
            <li parentName="ul">{`+Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`SOS Power`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`$790`}</strong>{` after Farm flag.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Colour of Lumina`}</strong>{` on path after Farm.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Colour of Lumina`}</strong>{` before last grapple up.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "lampmaster-42677hp-148"
      }}>{`Lampmaster 42677HP (1:48)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`18900XP, $3160, 3 Polished Chroma Catalyst`}<br parentName="p"></br>{`
`}{`Need > 310 speed to outspeed him T2. 312 confirmed working.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Switches off lights and attacks: 4 Lamps launch projectiles. Parry when lamps turn off.`}</li>
          <li parentName="ul">{`Jumps: Parry on landing.`}</li>
          <li parentName="ul">{`Power of its lamps: 1 Dark Attack, visual/audio pre attack cue?`}</li>
          <li parentName="ul">{`Tries to blind: 3 Physical, first swipe is later than it looks.`}</li>
          <li parentName="ul">{`Dark explosion: jumps and hits 1 on landing.`}</li>
        </ul>
      </blockquote>
      <p>{`In phase 1, you need to counter 1 or 2 attacks. Need about 1500 damage of extra counter damage, assuming Immolation crit. It's better to counter on the 2nd turn, since you will have Exposing applied. But any counter that isn't Gustave target is good enough 1st attack.`}</p>
      <h5 {...{
        "id": "turn-0-4"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
      </ul>
      <h5 {...{
        "id": "turn-1-9"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
        <li parentName="ul">{`Gustav: Tint Sciel`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Attack`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-5"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Powerful`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <p>{`Enter phase 2.`}</p>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Flying Combo: 4 hits, parry bit after audio cue`}</li>
          <li parentName="ul">{`Attacks with each arm: 4 hits, parry on audio cue?`}</li>
          <li parentName="ul">{`Vast ball of light: Jump, easy timing`}</li>
          <li parentName="ul">{`Sword of light: 1 hit, parry during it's swing at you`}</li>
        </ul>
      </blockquote>
      <p>{`You can dodge both moves, perfect dodge the Sword.`}</p>
      <h5 {...{
        "id": "turn-21"
      }}>{`Turn 2.1`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Tint Lune`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Attack`}</li>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "white-haired-man-049"
    }}>{`White-Haired Man (0:49)`}</h4>
    <p>{`Skip turn x4`}</p>
    <h2 {...{
      "id": "act-ii"
    }}>{`Act II`}</h2>
    <p>{`Start off at camp, party full healed. Go to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-4"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +9 Agility (13)`}</li>
        <li parentName="ul">{`Verso: +32 Might (32), +10 Agility (10)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-4"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Marking Shot, `}<strong parentName="li">{`Perfect Recovery`}</strong>{`, Quick Strike, Berserk Slash, Defiant Strike`}</li>
        <li parentName="ul">{`Verso: Equip Defiant Strike to Right-Bottom, Equip Berserk Slash Left-Middle`}</li>
      </ul>
    </Menu>
    <p>{`Do this menu before entering `}<strong parentName="p">{`Forgotten Battlefield`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon-2"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Lanceram`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-5"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso`}<ul parentName="li">
            <li parentName="ul">{`+At Death's Door`}</li>
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle`}<ul parentName="li">
            <li parentName="ul">{`+SOS Power > Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "forgotten-battlefield"
    }}>{`Forgotten Battlefield`}</h3>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "chalier-9724hp-024"
      }}>{`Chalier 9724HP (0:24)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`4134XP (NB), $593, 0-2 Polished Chroma Catalyst`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-10"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Dodge 1st attack`}</li>
        <li parentName="ul">{`Verso: Defiant Strike`}</li>
        <li parentName="ul">{`Let Verso die to Gradient`}</li>
        <li parentName="ul">{`Lune: Skip`}</li>
        <li parentName="ul">{`Maelle: Percee (1.1)`}</li>
      </ul>
    </Menu>
    <p>{`Buy `}<strong parentName="p">{`Inverted Affinity`}</strong>{` from Merchant ($9870).`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-6"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Inverted Affinity`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-2"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`-Exposing Attack`}</li>
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Critical Moment`}</li>
            <li parentName="ul">{`+Dodger`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "formation-1"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`-Maelle, +Sciel`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "dualliste-71106hp-140215"
      }}>{`Dualliste 71106HP (1:40/2:15)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`33072XP, $3950, Dualiso + Combo Attack I + 3 Polished Chroma Catalyst + 0-1 Recoat?`}<br parentName="p"></br>{`
`}{`Threshold between him getting 2 attacks before you is somewhere between 328 and 318 speed.`}</p>
      </blockquote>
      <p>{`Good or bad fight depends on targetting, bad fight loses ~30s.`}<br parentName="p"></br>{`
`}{`1st phase you need Sciel or Verso. 2nd phase you NEED Verso target at the start. If you don't get the right moves turn 1, you can refer to mediocre fight below.`}</p>
      <h5 {...{
        "id": "turn-0-5"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Note that if you hit all crits and he targets Verso with the jump attack move, you can kill off the first Berserk Slash.`}<br parentName="p"></br>{`
`}{`If that happens, you Immolation T1. After the transition, Intervention > Berserk Slash, and next turn Lune Tint Sciel, Berserk Slash > Intervention > Berserk Slash. You don't need to counter his moves in phase 2.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-11"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Energy Tint Verso / Immolation`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Intervention Verso`}</li>
        <li parentName="ul">{`Verso: Defiant Strike / Berserk Slash`}</li>
      </ul>
      <p>{`Phase transitions here. `}<strong parentName="p">{`Notation is good / bad fight`}</strong>{`. Good fight is ONLY if Verso is targeted on his 1st attack.`}<br parentName="p"></br>{`
`}{`If good fight, parry everything. If not, dodge everything, you want to do less than half his HP on this turn.`}</p>
      <h5 {...{
        "id": "turn-2-6"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack or Tint Sciel / Skip`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Intervention Verso > Berserk Slash / Tint if needed, else nothing`}</li>
      </ul>
      <p>{`Good fight kills here.`}</p>
      <h5 {...{
        "id": "turn-3-4"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Intervention Verso`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`This is an alternate strat, that can't get as good of a time, but is also faster than the above in bad cases. I recommend this variant if you get Lune target or AoE for Dualliste's 1st attack.`}</p>
      </blockquote>
      <h4 {...{
        "id": "mediocre-fight-200"
      }}>{`Mediocre Fight (2:00)`}</h4>
      <h5 {...{
        "id": "turn-1-12"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Tint Verso`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Attack`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If you can transition with a parry, go for it.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-2-7"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Tint Verso / Nothing`}</li>
        <li parentName="ul">{`Verso: Berserk Slash / Defiant Strike`}</li>
      </ul>
      <p>{`Phase change. Don't counter him this phase with this fight version, unless you transitioned off a parry and it's Verso target. In that case, play like the good fight 2nd phase.`}</p>
      <h5 {...{
        "id": "turn-21-1"
      }}>{`Turn 2.1`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Intervention Verso`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
      <p>{`Parry + Dodge AoE for AP generation.`}</p>
      <h5 {...{
        "id": "turn-3-5"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack / Skip (Skip saves ~4s)`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Intervention Verso`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "camp-2"
    }}>{`Camp`}</h3>
    <p>{`Go to Curator`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons-1"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lighterim +2 (9)`}</li>
      </ul>
      <h5 {...{
        "id": "upgrade-resources"
      }}>{`Upgrade Resources`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +2 Lumina (19)`}</li>
        <li parentName="ul">{`Sciel: +2 Lumina (20)`}</li>
      </ul>
    </Menu>
    <p>{`Option 2 to sleep.`}</p>
    <h3 {...{
      "id": "continent-1"
    }}>{`Continent`}</h3>
    <p>{`Fight group before Monoco Station`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "demineur-troubador-gault-015"
      }}>{`Demineur, Troubador, Gault (0:15)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`6890XP (NB), $988, Troubadim LV8 + Gaulteram LV8 + 0-1? Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-6"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Wildfire (Fail QTE)`}</li>
        <li parentName="ul">{`Verso: `}<ul parentName="li">
            <li parentName="ul">{`Shoot Mine then shoot Demineur 3 times.`}</li>
            <li parentName="ul">{`Defiant Strike Troubador`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel: Phantom Blade Gault`}</li>
      </ul>
    </Menu>
    <p>{`Menu before Monoco.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon-3"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Dualiso`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-7"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Combo Attack > At Death's Door `}</li>
            <li parentName="ul">{`+Critical Moment > First Strike (Swap)`}</li>
            <li parentName="ul">{`+Exposing Attack > Inverted Affinity (Swap)`}</li>
          </ul></li>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+At Death's Door`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-3"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Critical Moment`}</li>
          </ul></li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "monoco-station"
    }}>{`Monoco Station`}</h3>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "monoco-111599hp-030"
      }}>{`Monoco 111599HP (0:30)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`54000XP, $4360, 3 Polished Chroma Catalyst + 0-1 Recoat. Speed between 346-349`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-7"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation `}</li>
      </ul>
      <p>{`Dodge his Attack`}</p>
      <h5 {...{
        "id": "turn-1-13"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Energy Tint Lune`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Menu>
    <p>{`Menu before Stalact.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "lumina-4"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`(R3) +First Strike`}</li>
            <li parentName="ul">{`-Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Go to flag. Watch to see if you got a Recoat.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-5"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`If Recoat:`}</strong>{` Lune: Recoat, +11 Might, +37 Agility, +9 Luck`}</li>
        <li parentName="ul">{`Verso: +18 Agility (28)`}</li>
        <li parentName="ul">{`Maelle: +18 Might (50)`}</li>
        <li parentName="ul">{`Sciel: +1 Might (46), +5 Agility (5), +9 Luck (9)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-5"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +Mayhem, +Elemental Trick`}</li>
        <li parentName="ul">{`Lune: Equip Elemental Trick Top-Left`}</li>
        <li parentName="ul">{`Verso: +Powerful, +Leadership`}</li>
        <li parentName="ul">{`Verso: Equip Leadership Left-Top, Powerful Left-Bottom`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "stalact-51507hp-048"
      }}>{`Stalact 51507HP (0:48)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`21600XP, $1744, Polished Chroma Catalyst + 0-1 Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-8"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Ice Lance (Fail QTE)`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Gradient > Lightning Dance`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "old-lumiere"
    }}>{`Old Lumiere`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-8"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune`}<ul parentName="li">
            <li parentName="ul">{`+Energising Start I > First Strike (No Swap)`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-5"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune: `}<ul parentName="li">
            <li parentName="ul">{`-Dodger`}</li>
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`-Critical Burn`}</li>
            <li parentName="ul">{`-Dodger`}</li>
            <li parentName="ul">{`+First Strike`}</li>
            <li parentName="ul">{`+Inverted Affinity`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle: `}<ul parentName="li">
            <li parentName="ul">{`(R3) +Inverted Affinity`}</li>
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
        <li parentName="ul">{`Monoco:`}<ul parentName="li">
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Inverted Affinity`}</li>
            <li parentName="ul">{`+Energising Start I`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p><strong parentName="p">{`If no Recoat, talk to Merchant and buy Recoat`}</strong>{`.`}<br parentName="p"></br>{`
`}{`If you bought Recoat, after party splits go to flag with Lune party.`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`Only do this menu if not done earlier.`}</p>
      </blockquote>
      <h5 {...{
        "id": "upgrade-attributes-6"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Recoat, +14 Might, +37 Agility, +9 Luck`}</li>
        <li parentName="ul">{`Monoco: +78 Agility (78)`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "chevaliers-015"
      }}>{`Chevaliers (0:15)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`13662XP, $998, Battlum LV10 + 0-2 Polished Chroma Catalyst`}<br parentName="p"></br>{`
`}{`Verso outspeeds at 522 speed, 521 might work.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-9"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Rain of Fire left one (Default)`}</li>
        <li parentName="ul">{`Verso: (If alive, can shoot left one). Attack right one > Berserk Slash right one`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "renoir-140186hp-050"
      }}>{`Renoir 140186HP (0:50)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`51750XP (NB), $4990, Melarum + 3 Polished Chroma Catalyst + 0-2 Recoat`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Massive amount of chroma: Gradient once he jumps into the air.`}</li>
          <li parentName="ul">{`Melee combo: 5, 4th hit is later than it looks.`}</li>
          <li parentName="ul">{`Giant pool of chroma: jump`}</li>
          <li parentName="ul">{`Attacks from a distance: 4 hit, look for slowdown.`}</li>
          <li parentName="ul">{`Vanish an expeditioner: Gradient before he strikes black orb.`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-1-14"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Rain of Fire`}</li>
        <li parentName="ul">{`Lune: Wildfire fail QTE`}</li>
        <li parentName="ul">{`Verso: Powerful`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-8"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Energy Tint Lune`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
        <li parentName="ul">{`Maelle: Healing Tonic Lune if she didn't crit herself / nothing / offensive shift`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-6"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Leadership/Tonic. If you did Offensive Shift can just do the Leadership/Tonic`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "visages"
    }}>{`Visages`}</h3>
    <p><strong parentName="p">{`Talk to the Plazza Flag`}</strong>{`. `}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`If not done earlier`}</p>
      </blockquote>
      <h5 {...{
        "id": "upgrade-attributes-7"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Monoco: +78 Agility (78)`}</li>
      </ul>
    </Menu>
    <p>{`Go to Sorrow Mask (Northwest)`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Glass Canon`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go back to flag and warp to `}<strong parentName="p">{`Plazza`}</strong>{`.`}</p>
    <p>{`Go to Joyous Mask (Southwest)`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Confident Fighter`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-2"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`-Lune, +Lune, -Maelle, +`}<strong parentName="li">{`Monoco`}</strong></li>
      </ul>
      <h5 {...{
        "id": "pictos-9"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Monoco:`}<ul parentName="li">
            <li parentName="ul">{`+Stun Boost`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Glass Canon`}</li>
          </ul></li>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Confident Fighter > At Death's Door`}</li>
            <li parentName="ul">{`+First Strike > Energising Start`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-6"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Energising Start I`}</li>
            <li parentName="ul">{`(R3) +At Death's Door`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+At Death's Door`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "weapons-1"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Lanceram`}</li>
      </ul>
    </Menu>
    <p>{`Run into fight closest to flag.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "2-moisonneusse-hat-guy"
      }}>{`2 Moisonneusse, Hat Guy`}</h4>
      <ul>
        <li parentName="ul">{`Verso: Perfect Recovery`}</li>
        <li parentName="ul">{`Lune: Wildfire (Fail QTE)`}</li>
        <li parentName="ul">{`Monoco: Flee`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon-4"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Dualiso`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-10"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Glass Canon > Combo Attack (Swap)`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "formation-3"
      }}>{`Formation`}</h5>
      <p>{`-Monoco, +Sciel`}</p>
    </Menu>
    <p>{`Go to flag, warp to `}<strong parentName="p">{`Plazza`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "visages-185114hp"
      }}>{`Visages 185114HP`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Need 440 speed for phase 1`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Determination Mask: Parry, Jump, Parry. Very easy audio cues`}</li>
          <li parentName="ul">{`Build shields with Peace Mask: 4 Parries on audio cue`}</li>
          <li parentName="ul">{`Anxiety Mask: 2 Parry, slight delay from audio cue.`}</li>
          <li parentName="ul">{`Doubt Mask: 5 Parry, go off visual cues. 1st one is slower than it looks. Audio cue is too early.`}</li>
        </ul>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`If Lune is 11 Might, watch for crit damage and add Lune Shots T2 if needed).`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-10"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Shoot twice, Berserk Slash`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Interventiong`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <p>{`Parry & Counter for damage.`}</p>
      <h5 {...{
        "id": "turn-1-15"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Leadership`}</li>
        <li parentName="ul">{`Lune: (If damage low shoot up to 4 times), Wildfire (Finish Phase)`}</li>
      </ul>
      <h4 {...{
        "id": "mask-keeper-185114hp-156"
      }}>{`Mask Keeper 185114HP (1:56)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`157690XP, $11760, Immaculate + 6 Resplendent Chroma Catalyst x6 + 0-3 Recoat`}<br parentName="p"></br>{`
`}{`Need some amount of speed over 468.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Attacks the Expedition: 4 Parries, visual cue off the circle build up of his attack.`}</li>
          <li parentName="ul">{`Swing Combo: 3 Parry, 2nd Parry tiny delay after 1st.`}</li>
          <li parentName="ul">{`Attacks like a Storm: 4 parries, visual/audio cue.`}</li>
          <li parentName="ul">{`Sets fire to his sword: 3 quick parries into a gradient`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-11"
      }}>{`Turn 1.1`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Intervention`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-9"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Leadership / `}<em parentName="li">{`If 2-3 AoE Parries`}</em>{` Powerful`}</li>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Sciel: Intervention`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Menu>
    <p>{`Forced Camp here. Go to flag, then go to Curator.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-8"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: `}<em parentName="li">{`If not done earlier, +3 Might (14)`}</em>{`, +15 Luck (24)`}</li>
        <li parentName="ul">{`Verso: +17 Might (49), +1 Agility (29)`}</li>
        <li parentName="ul">{`Sciel: +15 Might (61)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-6"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: +Sealed Fate, +Card Weaver`}</li>
        <li parentName="ul">{`Sciel: Equip Card Weaver Right-Bottom, Equip Sealed Fate Left-Bottom, Equip Twilight Slash Right-Middle`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons-2"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lighterim +4 (13)`}</li>
        <li parentName="ul">{`Sciel: Scieleson +3 (8)`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "sirene"
    }}>{`Sirene`}</h3>
    <p>{`Start battle with a group of Ballets.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "ballets-027"
      }}>{`Ballets (0:27)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`21624XP (NB), $1410, Ballaro LV13`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-11"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Skip`}</li>
        <li parentName="ul">{`Lune: Wildfire (Fail QTE)`}</li>
        <li parentName="ul">{`Sciel: Skip`}</li>
      </ul>
      <p>{`They should kill both characters`}</p>
      <h5 {...{
        "id": "turn-1-16"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Monoco/Maelle: Flee`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Colour of Lumina`}</strong>{` near shadow Renoir.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-11"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`At Death's Door > Confident Fighter`}</li>
            <li parentName="ul">{`SOS Power > First Strike (No Swap)`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Confident Fighter > Augmented First Strike`}</li>
            <li parentName="ul">{`+Immaculate > Breaker`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-7"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`-Energising Start I`}</li>
            <li parentName="ul">{`+Critical Moment`}</li>
            <li parentName="ul">{`+At Death's Door`}</li>
          </ul></li>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`(L2+R3) +First Strike`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "glissando-350757hp-059"
      }}>{`Glissando 350757HP (0:59)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`51897XP, $2820, 1 Resplendent Chroma Catalyst`}<br parentName="p"></br>{`
`}{`515 speed seems to be the cutoff for him to not get 2 moves in T1.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Enchants its target: 1 hit. 2 explosions > Parry. Use rhythm.`}</li>
          <li parentName="ul">{`Smashes its head: 2 Parry, can visually/audio react`}</li>
          <li parentName="ul">{`Smashes its tail: 3 Parry, need to find cue. 1st visual on slowdown, 2nd audio, 3rd delayed audio.`}</li>
          <li parentName="ul">{`Summons ballets: 3 jumps, easy.`}</li>
          <li parentName="ul">{`Attacks with her fabric: one on each character, not sure on timing cue yet.`}</li>
        </ul>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`You can skip Verso Attack here, but will potentially need extra damage T1. Only do it if you're comfortable here.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-12"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Energy Tint Sciel`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Card Weaver > Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <p>{`If he does Enchant, consider adding a few shots for safety.`}</p>
      <h5 {...{
        "id": "turn-1-17"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Shoot till C Rank, Leadership`}</li>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Sciel: Gradient > Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "sirene-303990hp-108"
      }}>{`Sirene 303990HP (1:08)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`129744XP, $7050, Tisseron + Energising Turn + Resplendent Chroma Catalyst x3`}<br parentName="p"></br>{`
`}{`She goes frantic at 80%? HP? After she does, her next move will be Grand Ballet.`}<br parentName="p"></br>{`
`}{`If you transition her there with a parry off her 1st move, she will skip her 2nd move.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Glissandos: 2 Parries`}</li>
          <li parentName="ul">{`Charm: 1 Parry, same timing as Glissando enchants. 2 Explosions > Parry`}</li>
          <li parentName="ul">{`Seduce: Gradient`}</li>
          <li parentName="ul">{`Grand Ballet: 5 Hits, watch ballets + audio cue. 1st one is earlier than you'd think, last one you have to be patient for.`}</li>
        </ul>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`If Verso hits all crits, fail QTE on Twilight Slash`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-13"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Berserk Slash`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Card Weaver > Twilight Slash`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If she goes frantic before her move, you did too much damage. Adjust with QTEs next time.`}</p>
      </blockquote>
      <p>{`Parry Glissando's, she should go frantic`}</p>
      <h5 {...{
        "id": "turn-1-18"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Leadership`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
        <li parentName="ul">{`Sciel: Gradient > Sealed Fate`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "the-monolith"
    }}>{`The Monolith`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-4"
      }}>{`Formation`}</h5>
      <p>{`-Lune, -Verso, +Maelle, -Sciel`}</p>
    </Menu>
    <h4 {...{
      "id": "the-paintress"
    }}>{`The Paintress`}</h4>
    <p>{`Skip`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-5"
      }}>{`Formation`}</h5>
      <p>{`+Verso, -Maelle, +Lune, +Sciel`}</p>
      <h5 {...{
        "id": "weapon-5"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Tisseron`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-12"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Energising Turn > Combo Attack`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Combo Attack > Critical Moment`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Talk to `}<strong parentName="p">{`Merchant`}</strong>{` in Flying Waters.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-1"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`3 Colour of Lumina`}</li>
        <li parentName="ul">{`5 Resplendent Chroma Catalyst (Only need 4?)`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Weakness Gain`}</strong>{` at the end of the `}<strong parentName="p">{`Stone Wave Cliffs`}</strong>{` section. It's behind the statue on the right.`}<br parentName="p"></br>{`
`}{`Go to any flag along the way.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-9"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +9 Agility (46)`}</li>
        <li parentName="ul">{`Sciel: +9 Luck (18)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-7"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +Storm Caller`}</li>
        <li parentName="ul">{`Lune: Equip Storm Caller Right-Top`}</li>
      </ul>
    </Menu>
    <p>{`In Lumiere, fight the first battle with Chevaliers.`}</p>
    <h4 {...{
      "id": "chevaliers"
    }}>{`Chevaliers`}</h4>
    <ul>
      <li parentName="ul">{`Lune Ice Lance, rest skip. Bring in 2nd party, flee.`}</li>
    </ul>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "renoir-2-370890hp-111"
      }}>{`Renoir 2 370890HP (1:11)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`173736XP, $8520, Second Chance + 3 Resplendent Chroma Catalyst`}<br parentName="p"></br>{`
`}{`724 Speed is the cutoff here. 732 doesn't work.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Attempts to Vanish: 2 hit, Parry into Gradient. Parry right before he hits black orb. Gradient when back turned.`}</li>
          <li parentName="ul">{`Melee Combo: 6 hit, gradient last?`}</li>
          <li parentName="ul">{`Incredible amount of chroma: 2 Parries, Gradient. Parry as soon as you see the ball shrink.`}</li>
          <li parentName="ul">{`Waves of Chroma: 5 Parry, last is delayed`}</li>
          <li parentName="ul">{`Attacks from a distance: 4 attacks, 1st 3 parry on slow down. 4th is ground pound.`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-0-14"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > 1 Shot, Leadership`}</li>
        <li parentName="ul">{`Lune: Storm Caller`}</li>
        <li parentName="ul">{`Sciel: Focused Fortell`}</li>
      </ul>
      <p>{`Dodge here if possible.`}</p>
      <h5 {...{
        "id": "turn-1-19"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Powerful`}</li>
        <li parentName="ul">{`Sciel: Sealed Fate`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
      <p>{`If no counter T1, I recommend countering here. It's not necessary, but damage is VERY tight without it.`}</p>
      <h5 {...{
        "id": "turn-2-10"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Shots, Berserk Slash / Defiant Strike / Attack. You need to control damage here to get him as close to half as possible.`}</li>
        <li parentName="ul">{`Sciel: Shoot until 2 AP, Gradient > Sealed Fate`}</li>
      </ul>
      <p>{`This should kill, if not get fucked.`}</p>
    </Menu>
    <p>{`Menu before Paintress`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-13"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Weakness Gain > `}<strong parentName="li">{`SOS Power`}</strong></li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "the-paintress-482157hp-413"
      }}>{`The Paintress 482157HP (4:13)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`173736XP, $8519, Painted Power + 3 Resplendent Chroma Catalyst`}<br parentName="p"></br>{`
`}{`Need >= 744 Speed `}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Void Meteors: 7 projectiles left to right. They kind of explode before launching, parry as soon as you see it.`}</li>
          <li parentName="ul">{`Gradient Attack: 1 Gradient`}</li>
          <li parentName="ul">{`Chroma Waves: 4 hits, 2nd one right after 1st. Audio cue works. Parry on start of cue.`}</li>
          <li parentName="ul">{`Scatters Chroma: 5 hits, parry once the black waves go into the circle. No more waves around circle > parry.`}</li>
          <li parentName="ul">{`Manipulates Rocks from the Monolith: 3 hit AoE, parry after the rock moves back?`}</li>
        </ul>
      </blockquote>
      <p>{`Parry only the AoE moves, and you can dodge 1 to avoid the counter unless noted otherwise.`}<br parentName="p"></br>{`
`}{`You want to slightly underdamage, so you can kill with the parry counter on her 4th move.`}</p>
      <h5 {...{
        "id": "turn-0-15"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Berserk Slash`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <p>{`Dodge Meteors`}</p>
      <h5 {...{
        "id": "turn-1-20"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Leadership (If B-Rank, you might need to parry the 3rd brush attack with Lune in phase 2)`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Rush`}</li>
      </ul>
      <p>{`Parry Gradient, Parry Chroma Waves and counter.`}</p>
      <h5 {...{
        "id": "turn-2-11"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Powerful`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
        <li parentName="ul">{`Sciel: Gradient > Sealed Fate (Don't fail QTE)`}</li>
      </ul>
      <p>{`Parry all 5 chroma scatters, transition with counter.`}</p>
      <h4 {...{
        "id": "phase-2"
      }}>{`Phase 2`}</h4>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Summons giant brush of light: 3 hit aoe, parry on swing. Has audio cue similar to Chroma Waves`}</li>
          <li parentName="ul">{`Flies into the air: 5 hit, 2nd dodge on twirl, 3rd is slow, 4th is right after 3rd.`}</li>
          <li parentName="ul">{`Tears reality apart: 5 projectiles, dodge / parry at their "arc". Randomly start from left or right.`}</li>
          <li parentName="ul">{`Paintress unleashes: 7 single target into AoE`}</li>
          <li parentName="ul">{`Attacks from afar: Jump into 3 parry. Patient for jump`}</li>
        </ul>
      </blockquote>
      <p>{`You might not need all this damage, but you do need to keep doing stuff to generate Gradient`}</p>
      <h5 {...{
        "id": "turn-1-21"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Berserk Slash`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Gradient > Sealed Fate`}</li>
      </ul>
      <p>{`She will get 2 turns here. Giant brush > parry first 2 and dodge 3rd.`}<br parentName="p"></br>{`
`}{`Dodge all the moves of flies into the air. No perfect dodges required, just survive.`}</p>
      <h5 {...{
        "id": "turn-2-12"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lightning Dance (She outspeeds because Rush wore off for the others, might depend on speed)`}</li>
        <li parentName="ul">{`Verso: Attack > Powerful`}</li>
        <li parentName="ul">{`Sciel: Gradient > Sealed Fate`}</li>
      </ul>
      <h4 {...{
        "id": "phase-3-72323hp"
      }}>{`Phase 3 ~72323HP`}</h4>
      <h5 {...{
        "id": "turn-1-22"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Skip / Attack if Paintress healed Verso`}</li>
        <li parentName="ul">{`Verso: Defiant Strike`}</li>
        <li parentName="ul">{`Sciel: Sealed Fate`}</li>
      </ul>
    </Menu>
    <h2 {...{
      "id": "act-iii"
    }}>{`Act III`}</h2>
    <h3 {...{
      "id": "camp-3"
    }}>{`Camp`}</h3>
    <p>{`Talk to everyone, talk to campfire, Option 2`}</p>
    <h3 {...{
      "id": "abbest-cave"
    }}>{`Abbest Cave`}</h3>
    <p>{`Talk to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-10"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +30 Defense (30), +3 Luck (3)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-8"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +Phantom Strike, +Last Chance, +Stendhal,`}</li>
        <li parentName="ul">{`Maelle: Equip Last Chance Left-Top, Phantom Strike Left-Middle, Stendhal Left-Bottom`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-6"
      }}>{`Formation`}</h5>
      <p>{`Setup party so order is Verso, Maelle, Sciel`}</p>
      <h5 {...{
        "id": "pictos-14"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle`}<ul parentName="li">
            <li parentName="ul">{`+Painted Power`}</li>
            <li parentName="ul">{`+Immaculate`}</li>
            <li parentName="ul">{`+Confident Fighter`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-8"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle`}<ul parentName="li">
            <li parentName="ul">{`+Dead Energy II`}</li>
            <li parentName="ul">{`+Critical Moment`}</li>
            <li parentName="ul">{`+Energising Start`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "abbest-161636hp-011"
      }}>{`Abbest 161636HP (0:11)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`2 Resplendent, 5 Lumina`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-16"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Tint Maelle`}</li>
        <li parentName="ul">{`Maelle: Shoot Weakpoint, Stendhal`}</li>
      </ul>
    </Menu>
    <p>{`Go to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons-3"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Barrier Breaker: Barrier Breaker +4 (19)`}</li>
      </ul>
      <h5 {...{
        "id": "upgrade-expedition-resources"
      }}>{`Upgrade Expedition Resources`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +11 Lumina (40)`}</li>
        <li parentName="ul"><strong parentName="li">{`Upgrade Healing Tint`}</strong></li>
      </ul>
      <p>{`Leave to Continent`}</p>
    </Menu>
    <p>{`Go to Chromatic Demineur.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon-6"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Barrier Breaker`}</li>
      </ul>
      <h5 {...{
        "id": "lumina-9"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`-Energising Start I`}</li>
            <li parentName="ul">{`(R2) +At Death's Door`}</li>
            <li parentName="ul">{`+Augmented First Strike`}</li>
            <li parentName="ul">{`+SOS Power`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "chromatic-demineur-hp-014"
      }}>{`Chromatic Demineur ?HP (0:14)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`665280XP, $11543, 2 Grandiose + 5 Lumina`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-17"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Skip`}</li>
        <li parentName="ul">{`Maelle: Last Chance`}</li>
        <li parentName="ul">{`Sciel: Intervention Maelle`}</li>
        <li parentName="ul">{`Maelle: Shoot mine till dead.`}</li>
      </ul>
    </Menu>
    <p>{`Head in Sprong's direction, Camp.`}</p>
    <h4 {...{
      "id": "camp-4"
    }}>{`Camp`}</h4>
    <p>{`Talk to Esquie 2-3 times to get through dialogue.`}<br parentName="p"></br>{`
`}{`Talk to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-11"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +21 Defense (51)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-9"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: +Fortune Fury`}</li>
        <li parentName="ul">{`Sciel: Equip Fortune Fury Left-Middle`}</li>
        <li parentName="ul">{`Maelle: +Guard Down`}</li>
        <li parentName="ul">{`Maelle: Equip Guard Down Right-Middle`}</li>
      </ul>
      <h5 {...{
        "id": "upgrade-weapons-4"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Barrier Breaker +1 (20)`}</li>
      </ul>
      <h5 {...{
        "id": "upgrade-expedition-resources-1"
      }}>{`Upgrade Expedition Resources`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +5 Lumina (51)`}</li>
        <li parentName="ul"><em parentName="li">{`Upgrade Healing Tint if you haven't already`}</em></li>
      </ul>
      <p>{`Leave Camp.`}</p>
    </Menu>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-15"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+First Offensive > Immaculate`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-10"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Glass Canon`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Go to Sprong`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "sprong-3964471hp-023"
      }}>{`Sprong 3964471HP (0:23)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1056000XP, $11543, 3 Grandiose`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-18"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Defiant Strike`}</li>
        <li parentName="ul">{`Maelle: Last Chance`}</li>
        <li parentName="ul">{`Sciel: Intervention Maelle`}</li>
        <li parentName="ul">{`Maelle: Stendhal`}</li>
      </ul>
    </Menu>
    <p><strong parentName="p">{`Use Chroma Elixer!`}</strong>{` Go to Glaisum fight.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-16"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Cheater`}</li>
            <li parentName="ul">{`+Stun Boost`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-11"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Immaculate`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "glaisum-fight-028"
      }}>{`Glaisum Fight (0:28)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1071447XP, $9567,	0-2? Grandiose, 0-2 Resplendant`}<br parentName="p"></br>{`
`}{`Check results screen for Grandiose drops.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-19"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack Middle > Shoot Right 3 times, Energy Tint Sciel`}</li>
        <li parentName="ul">{`Maelle: Last Chance`}</li>
        <li parentName="ul">{`Sciel: Fortune Fury Maelle > Intervention Maelle`}</li>
        <li parentName="ul">{`Maelle: Phantom Strike`}</li>
      </ul>
    </Menu>
    <p>{`Go to Camp.`}</p>
    <h3 {...{
      "id": "camp-5"
    }}>{`Camp`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapons-2"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Glaisum`}</li>
      </ul>
      <h5 {...{
        "id": "lumina-12"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Painted Power`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Talk to Esquie till Francois.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "francois-012"
      }}>{`Francois (0:12)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`14175XP, $815`}</p>
      </blockquote>
      <p>{`Healing Tint > Shoot x3, Attack > Berserk Slash`}</p>
    </Menu>
    <p>{`Go to Thunder Eveque.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "thunder-eveque-016"
      }}>{`Thunder Eveque (0:16)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1518750XP, $15465, 2 Grandiose + 5 Lumina`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-20"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Skip`}</li>
        <li parentName="ul">{`Maelle: Last Chance`}</li>
        <li parentName="ul">{`Sciel: Intervention Maelle`}</li>
        <li parentName="ul">{`Maelle: Stendhal`}</li>
      </ul>
    </Menu>
    <p><strong parentName="p">{`Use Chroma Elixer!`}</strong>{` Go to Serpenphare.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "serpenphare-027"
      }}>{`Serpenphare (0:27)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`2340000XP, $22240, 1 Perfect + 3 Grandiose`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-21"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Energy Tint Sciel`}</li>
        <li parentName="ul">{`Maelle: Last Chance`}</li>
        <li parentName="ul">{`Sciel: Fortune Fury Maelle > Intervention Maelle`}</li>
        <li parentName="ul">{`Maelle: Stendhal`}</li>
      </ul>
    </Menu>
    <p>{`Go to Sniper fight.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "sniper-fight-027"
      }}>{`Sniper Fight (0:27)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`638730XP, $9808, 1-3 Grandiose?`}</p>
      </blockquote>
      <p>{`Watch for Grandiose Catalysts drops after the battle! I think one always drops.`}</p>
      <h5 {...{
        "id": "turn-0-22"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack Stalact > Shoot Stalact once, Shoot right 3 times, Energy Tint Sciel`}</li>
        <li parentName="ul">{`Maelle: Last Chance`}</li>
        <li parentName="ul">{`Sciel: Fortune Fury Maelle > Intervention Maelle`}</li>
        <li parentName="ul">{`Maelle: Phantom Strike`}</li>
      </ul>
    </Menu>
    <p>{`Go to Renoir's Drafts.`}</p>
    <h4 {...{
      "id": "renoirs-drafts"
    }}>{`Renoir's Drafts`}</h4>
    <p>{`Need to pick up Grandiose Catalysts according to how many drops you got.`}<br parentName="p"></br>{`
`}{`If only 1 drop, need to get 3.`}</p>
    <p>{`Talk to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-12"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +48 Defense (99)`}</li>
      </ul>
      <h5 {...{
        "id": "upgrade-weapons-5"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Glaisum +4 (33)`}</li>
      </ul>
    </Menu>
    <p>{`This menu is optimally done during the long jump down to Simon.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-17"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`(Triangle) +Energy Master > Cheater`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Breaking Death`}</li>
            <li parentName="ul">{`+Sniper`}</li>
            <li parentName="ul">{`+Second Chance`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle`}<ul parentName="li">
            <li parentName="ul">{`(Triangle) +Cheater > Painted Power`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-13"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: `}<ul parentName="li">
            <li parentName="ul">{`(R3) +Stun Boost`}</li>
            <li parentName="ul">{`+Painted Power`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`Reset (Hold Triangle)`}</li>
            <li parentName="ul">{`+Inverted Affinity`}</li>
            <li parentName="ul">{`(L2) +First Strike`}</li>
            <li parentName="ul">{`+Cheater`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`Reset (Hold Triangle)`}</li>
            <li parentName="ul">{`+First Strike`}</li>
            <li parentName="ul">{`+Energising Start`}</li>
            <li parentName="ul">{`+Cheater`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "simon-p1-022"
      }}>{`Simon P1 (0:22)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1485000XP, $25220`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-23"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Skip > Defiant Strike`}</li>
        <li parentName="ul">{`Maelle: Skip > Guard Down`}</li>
        <li parentName="ul">{`Sciel: Intervention Maelle`}</li>
        <li parentName="ul">{`Maelle: Stendhal`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "simon-p2-033"
      }}>{`Simon P2 (0:33)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1237500XP (NB), $25220`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-24"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Healing Tint Self > Shoot once, Defiant Strike`}</li>
        <li parentName="ul">{`Maelle: `}<strong parentName="li">{`Guard Down`}</strong>{` > Last Chance`}</li>
        <li parentName="ul">{`Sciel: Fortune Fury Maelle > Intervention Maelle`}</li>
        <li parentName="ul">{`Maelle: Stendhal`}</li>
      </ul>
    </Menu>
    <p>{`Time on fight end.`}</p>
    <h2 {...{
      "id": "archive"
    }}>{`Archive`}</h2>
    <h4 {...{
      "id": "spring-meadows-lanceram-volester-abbest-70xp-216-019"
    }}>{`Spring Meadows Lanceram Volester Abbest 70XP $216 (0:19)`}</h4>
    <h5 {...{
      "id": "turn-0-25"
    }}>{`Turn 0`}</h5>
    <ul>
      <li parentName="ul">{`Gustav`}<ul parentName="li">
          <li parentName="ul">{`Shoot Volester 3 times to kill (main body, hitting weakness does less)`}</li>
          <li parentName="ul">{`Then shoot other weakpoints and attack Lanceram (default)`}</li>
        </ul></li>
      <li parentName="ul">{`Lune: Ice Lance Abbest (default)`}</li>
    </ul>
    <p>{`Parry Lanceram, Abbest dies to burn`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "flying-waters-bruler--cruleram-028"
      }}>{`Flying Waters Bruler & Cruleram (0:28)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1069XP, $400, 2 Chroma Catalyst?`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-23"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot Bruler`}</li>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Maelle: Shoot Bruler Weakpoint, Swift Strike Bruler`}</li>
      </ul>
      <p>{`Dodge Cruleram, no need to parry.`}</p>
      <h5 {...{
        "id": "turn-2-13"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot Cruleram`}</li>
        <li parentName="ul">{`Lune: Skip`}</li>
        <li parentName="ul">{`Maelle: Percee Cruleram`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "swc-rocher-3367hp-1575xpnb-316-011"
    }}>{`SWC Rocher 3367HP 1575XP(NB) $316 (0:11)`}</h4>
    <ul>
      <li parentName="ul">{`Lune: Wildfire (fail QTE) `}</li>
      <li parentName="ul">{`Gustav: Marking Shot`}</li>
      <li parentName="ul">{`Maelle: Percee`}</li>
    </ul>
    <h2 {...{
      "id": "timings"
    }}>{`Timings`}</h2>
    <h3 {...{
      "id": "spring-meadows-1"
    }}>{`Spring Meadows`}</h3>
    <p>{`The $720 chroma detour takes 11.5s.`}<br parentName="p"></br>{`
`}{`Empowering Attack Picto is ~15s detour after Eveque.`}</p>
    <h3 {...{
      "id": "flying-waters-1"
    }}>{`Flying Waters`}</h3>
    <p>{`The Bruler than jumps down after Manor can be done pretty quick. $466, 1340XP, Bruleram.`}<br parentName="p"></br>{`
`}{`The Bruler + Crueler fight gives 1069XP $400`}<br parentName="p"></br>{`
`}{`Money pickups after tunnel cost ~6.5s for $990`}</p>
    <h3 {...{
      "id": "esquies-nest-1"
    }}>{`Esquie's Nest`}</h3>
    <p>{`Backtracking after Francois is 12s faster, but loses $1305 and Colour of Lumina.`}<br parentName="p"></br>{`
`}{`Flagging after Esquie saves ~13s, but loses Energising Start III.`}</p>
    <h3 {...{
      "id": "visages-1"
    }}>{`Visages`}</h3>
    <p>{`Killing self with Wildfire + Perfect Recovery > Flee: `}{`~`}{`14.5s`}<br parentName="p"></br>{`
`}{`Killing self with Wildfire + Perfect Recovery > 2nd party: `}{`~`}{`21s`}<br parentName="p"></br>{`
`}{`Killing self with 2 Moisonneusse (2 short combo) > `}{`~`}{`34s`}</p>
    <h3 {...{
      "id": "sirene-1"
    }}>{`Sirene`}</h3>
    <p>{`Standard Wildfire Ballet death: 29s`}<br parentName="p"></br>{`
`}{`Enemies before Glissando: 32s`}</p>
    <h3 {...{
      "id": "other"
    }}>{`Other`}</h3>
    <p>{`Upgrading Healing Tint when near curator: 4s`}</p>
    <h2 {...{
      "id": "scribbles"
    }}>{`Scribbles`}</h2>
    <p>{`Sciel needs 18 Luck, can hold off on some of it till Renoir 2 if I want to invest more might.`}<br parentName="p"></br>{`
`}{`At LVL30, she will need 3 Agility 18 Luck to have EXACTLY enough for Paintress.`}<br parentName="p"></br>{`
`}{`Verso doesn't need to be the fastest for Paintress with Auto Rush (even though we're rushing ourselves). No idea why.`}</p>
    <p>{`For Renoir 2, without Weakness Gain Lune can enable 4 Agility 18 Luck Sciel with 49 Agility 24 Luck.`}<br parentName="p"></br>{`
`}{`In other words, substitute 3 Might for 3 Agility on Lune to get 1 more Might on Sciel.`}</p>
    <p>{`Grim Harvest doesn't work on Faketress. Harvest does, but doesn't consume Foretell.`}</p>
    <p>{`Can probably delay Maelle might investment till Old Lumiere. Should hit just around the the threshold with marking shot and verso might investment.`}</p>
    <p>{`Looks like Sciel doesn't need any might to kill Gault with Phantom Blade`}</p>
    <p>{`Renoir 3 Setup: Don't touch Verso, give Sciel Weakness Gain and Auto Rush Lumina`}</p>
    <h2 {...{
      "id": "changelog"
    }}>{`Changelog`}</h2>
    <h5 {...{
      "id": "80525"
    }}>{`8/05/25`}</h5>
    <ul>
      <li parentName="ul">{`Add note to check drops on Glaisum fight, can drop Grandiose`}</li>
      <li parentName="ul">{`Minor fixes`}</li>
    </ul>
    <h5 {...{
      "id": "80425"
    }}>{`8/04/25`}</h5>
    <ul>
      <li parentName="ul">{`Skip Energy Tint in Spring Meadows`}</li>
      <li parentName="ul">{`Mark Ice Lance on Luster in Flying Waters as optional`}</li>
      <li parentName="ul">{`Note optimal menu timing for SWC`}</li>
      <li parentName="ul">{`Pick up SOS Power in SWC`}</li>
      <li parentName="ul">{`Equip SOS Power to Maelle before Forgotten Battlefield`}</li>
      <li parentName="ul">{`Skip Continent Color of Lumina`}</li>
      <li parentName="ul">{`Move flag in notes before Sirene to camp`}</li>
      <li parentName="ul">{`Sirene pictos & lumina menu adjusted for SOS Power`}</li>
      <li parentName="ul">{`Mentioned that you might need to parry an extra hit in Paintress P2 if Verso Leadership was not C-Rank`}</li>
      <li parentName="ul">{`Cut 1 Lumina from Maelle in Act 3`}</li>
      <li parentName="ul">{`Cut Floating Cemetary, added camp before Sprong. Menus adjusted for SOS Power instead of Auto Powerful`}</li>
      <li parentName="ul">{`Use Chroma Elixer before Glaisum fight`}</li>
      <li parentName="ul">{`Cut flag from Camp before Francois`}</li>
      <li parentName="ul">{`Added Healing Tint to Francois fight`}</li>
      <li parentName="ul">{`Chroma Elixer before Serpenphare`}</li>
      <li parentName="ul">{`Sniper fight changed to use Fortune Fury instead.`}</li>
      <li parentName="ul">{`Flag before Simon adjusted, max out Defense instead of putting into might.`}</li>
      <li parentName="ul">{`Slight change to menu before Simon. Added note to do it during the jump.`}</li>
      <li parentName="ul">{`Simon P1 changed to accomodate SOS Power instead of Auto Powerful`}</li>
    </ul>
    <h5 {...{
      "id": "70825"
    }}>{`7/08/25`}</h5>
    <ul>
      <li parentName="ul">{`Slight Chroma route improvement. Skip $999 in Flying Waters and $790 in SWC. Get $1775 on Continent after Energising Start I, by Chromatic Bruler.`}</li>
    </ul>
    <h5 {...{
      "id": "70425"
    }}>{`7/04/25`}</h5>
    <ul>
      <li parentName="ul">{`Cut 3rd Energy Tint, skip Spring Meadows Tint`}</li>
      <li parentName="ul">{`Cut Resplendant pickup in Visages`}</li>
      <li parentName="ul">{`No longer need to attack Ballets in Sirene`}</li>
      <li parentName="ul">{`Adjusted stat attribution before Abbest, Maelle gets 3 Luck to get 50% crit for Chromatic Demineur`}</li>
      <li parentName="ul">{`Delayed Weapon upgrade until after Abbest, so you have enough Resplendant for 19`}</li>
      <li parentName="ul">{`Delayed first Maelle Lumina upgrade until after Abbest`}</li>
      <li parentName="ul">{`Adjusted Maelle Lumina menus before Abbest, Chromatic Demineur, Sprong`}</li>
      <li parentName="ul">{`Flag in Floating Cemetary after Chalier now`}</li>
      <li parentName="ul">{`Maelle now gets Auto Powerful before Sprong (damage is needed now with 3 Luck in stats)`}</li>
      <li parentName="ul">{`Maelle re-equips Confident Fighter after Sprong, Verso gets Immaculate instead of Confident Fighter`}</li>
      <li parentName="ul">{`Adjusted Lumina menus for Sciel & Verso before Simon (I think)`}</li>
    </ul>
    <h5 {...{
      "id": "7325"
    }}>{`7/3/25`}</h5>
    <ul>
      <li parentName="ul">{`First Draft`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      